import { useContext } from "react";
import Link from "next/link";
import { SbEditableBlok, sbEditable } from "@storyblok/storyblok-editable";
import { ChevronDown } from "../../constants/icons";
import { CommonDataContext } from "../../context/CommonDataContext";
import { getStyleCss } from "../../helper/css_style";
import { createInternalLink } from "../../utils/links/createInternalLink/createInternalLink";

export interface BreadcrumbsProps {
  blok: SbEditableBlok;
}

export function Breadcrumbs({ blok }: BreadcrumbsProps) {
  const { links } = useContext(CommonDataContext);

  let styles = {};
  if (blok?.custom_style?.length > 0) {
    styles = getStyleCss(blok.custom_style, styles);
  }

  return (
    <div {...sbEditable(blok)} style={styles} className="flex" aria-label="Breadcrumbs">
      {blok?.list?.map((nestedBlok: SbEditableBlok, index: number) => {
        const isLastBreadcrumb = index === blok.list.length - 1;
        const link = createInternalLink({ linkId: nestedBlok.links?.id, links });

        return isLastBreadcrumb ? (
          <p className="text-sm text-typography-secondary" key={nestedBlok._uid}>
            {nestedBlok.displayName}
          </p>
        ) : (
          <b className="flex items-center gap-1 font-semibold text-sm" key={nestedBlok._uid}>
            <Link href={link} passHref prefetch={false}>
              <a href={link}>{nestedBlok.displayName}</a>
            </Link>
            <ChevronDown className="-rotate-90 w-4 h-3 text-typography-secondary" data-testid="right-arrow" />
          </b>
        );
      })}
    </div>
  );
}

export default Breadcrumbs;
